module.exports = new __parcel__URL__("C8S2.d383a442.png").toString();